import React, { useState, useEffect,useMemo,useRef  } from "react";
import ReactMarkdown from 'react-markdown';
import { useSnackbar } from "../../SnackbarProvider";
import { requestUrl } from "../../requestUrl";
import { Grid, Box, Button,IconButton } from '@mui/material';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import rehypeRaw from 'rehype-raw'; 
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import './studydoccss.css';
import 'katex/dist/katex.min.css';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import cpp from 'react-syntax-highlighter/dist/esm/languages/hljs/cpp';
import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs'; // 选择一个样式
import { useTranslation } from 'react-i18next';
import Draggable from "react-draggable"; // 用于拖动窗口
import { ResizableBox } from "react-resizable"; // 用于调整尺寸
import "react-resizable/css/styles.css"; // 样式文件
import ChatWindow from "../ChatWindow/ChatWindow";

import FolderIcon from '@mui/icons-material/Folder';
import DescriptionIcon from '@mui/icons-material/Description';
import './studydoccss.css';
import remarkGfm from 'remark-gfm';
import CustomButton from '../../components/CustomButton';
import { Tabs, Tab } from "@mui/material";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Pagination,Modal,Checkbox ,TextField,FormControl,Popover,MenuItem,Select } from '@mui/material';

import { getColorDark,getColorLight,getTheme } from '../../ColorManager';
import WangEditorComponentCommon from "./WangEditorComponentCommon";
import WangEditorComponent from "../ProblemCollection/WangEditorComponent";
import LoadingData from "../dataloading";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

SyntaxHighlighter.registerLanguage('cpp', cpp);



// ImageTabs component for each group
const ImageTabs = ({ imageUrls }) => {
  const [selectedImage, setSelectedImage] = useState(0); // Tracks the selected image in the group

  const handleImageChange = (event, newValue) => {
    setSelectedImage(newValue); // Update the selected image
  };

  return (
    <Box mt={2}>
      {/* Image Tabs for the group */}
      <Tabs value={selectedImage} onChange={handleImageChange}>
        {imageUrls.map((url, index) => (
          <Tab label={`<${index + 1}>`} key={index} />
        ))}
      </Tabs>

      {/* Display the selected image */}
      <Box mt={2}>
        <img
          src={imageUrls[selectedImage]}
          alt={`Selected Image`}
          style={{ maxWidth: '80%', height: 'auto' }} 
        />
      </Box>
    </Box>
  );
};

// Function to parse image groups from markdown content
const parseImageGroups = (markdown) => {
  const groupRegex = /<!-- group:(.*?) -->([\s\S]*?)<!-- endgroup -->/g;
  let groups = [];
  let match;

  while ((match = groupRegex.exec(markdown)) !== null) {
    const groupName = match[1];
    const images = match[2].match(/!\[.*?\]\((.*?)\)/g) || [];
    const imageUrls = images.map((image) => image.match(/\((.*?)\)/)[1]); // Extract URLs from image syntax
    groups.push({ groupName, imageUrls });
  }

  return groups;
};






const StudyDocumentComponent = () => {
    const showSnackbar = useSnackbar();
    const [isLoading, setIsLoading] = useState(false);
    const [treeData, setTreeData] = useState([]);
    const [markdownContent, setMarkdownContent] = useState('');
    const [copied, setCopied] = useState(null);
    const { t } = useTranslation();

    const [loadingText,setLoadingText] = useState('loading');
    const [tabIndex, setTabIndex] = useState(0);

    const [colorManager, setColorManager] = useState(getColorDark());

    const [selectedDocuemntID,setSelectedDocuemntID] = useState(0);
    const [treeDataFolder, setTreeDataFolder] = useState([]);
    const get_color_by_name = (name) => {

      const item = colorManager.find(item => item.container === name);
      return item.value;
    }


 

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const dataToSend = { id: 1 };
                const data = await requestUrl(dataToSend, "get_md_documents", showSnackbar);
                if (data.status === "success") {

                  const tree = buildTree(data.data);
                  const tree11 = buildTree11(data.data);
                  setTreeDataFolder(tree11);
                  console.log('Tree Data:', tree); // 打印数据查看结构
                  setTreeData(tree);
                  setFilteredTree(tree); // 初始值显示完整树
                }
            } catch (error) {
                console.error("获取数据时出错:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);


    

    const handleCopy = (code) => {
        navigator.clipboard.writeText(code);
        setCopied(code); // 用来显示复制状态
        setTimeout(() => setCopied(null), 2000); // 2秒后恢复
    };



    const handlePrint = () => {
        const newWindow = window.open();
        newWindow.document.write(`<pre>${markdownContent}</pre>`);
        newWindow.print();
    };

    const handleExportWord = () => {
        const blob = new Blob([markdownContent], {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "document.docx";
        link.click();
    };

    const handleExportMarkdown = () => {
        const blob = new Blob([markdownContent], { type: "text/markdown" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "document.md";
        link.click();
    };

    const [windowSize, setWindowSize] = useState({ width: 500, height: window.innerHeight * 0.95});
    const [isWindowVisible, setIsWindowVisible] = useState(false); // 控制窗口的显示
  
    // 处理调整窗口大小
    const handleResize = (event, { size }) => {
      setWindowSize(size);
    };
  
    // 显示窗口
    const handleOpenWindow = () => {
      setIsWindowVisible(true);
    };
  
    // 关闭窗口
    const handleCloseWindow = () => {
      setIsWindowVisible(false);
    };

    const [messages, setMessages] = useState([]);
    const [inputText, setInputText] = useState(''); // 文本框的值

    const handleSendMessage = async (message) => {
        
    }


  // 构建树形结构
  const buildTree = (data) => {
    const map = new Map();
    const tree = [];

    // 构建每个节点的引用
    data.forEach(item => {
      map.set(item.id, { ...item, children: [] });
    });

    // 构建树形结构
    data.forEach(item => {
      if (item.pid === 0) {
        tree.push(map.get(item.id)); // 根节点
      } else {
        const parent = map.get(item.pid);
        if (parent) {
          parent.children.push(map.get(item.id)); // 添加子节点
        }
      }
    });

    return tree;
  };



  const buildTree11 = (data) => {
    const map = new Map();
    const tree = [];
  
    // 预先筛选掉 ftype 为 "file" 的数据
    const filteredData = data.filter(item => item.ftype === "folder");
  
    // 构建每个节点的引用
    filteredData.forEach(item => {
      map.set(item.id, { ...item, children: [] });
    });
  
    // 构建树形结构
    filteredData.forEach(item => {
      if (item.pid === 0) {
        tree.push(map.get(item.id)); // 根节点
      } else {
        const parent = map.get(item.pid);
        if (parent) {
          parent.children.push(map.get(item.id)); // 添加子节点
        }
      }
    });
  
    return tree;
  };

  const renderTree = (nodes) => {
    return nodes.map((node) => {
      const Icon = node.ftype === "folder" ? FolderIcon : DescriptionIcon;
      
      // 设置不同颜色
      const iconColor = node.ftype === "folder" ? "#06374C" : "green";  // 文件夹蓝色，文件绿色
      const textColor = node.ftype === "folder" ? "darkblue" : "darkgreen";  // 文件夹文字蓝色，文件文字绿色
  
      return (
        <TreeItem
          sx={{ color: textColor }}
          key={node.id}
          nodeId={String(node.id)}
          label={
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <Icon style={{ marginRight: 6, color: iconColor }} />
              {node.name}
            </span>
          }
          onClick={() => handleNodeClick(node)}
        >
          {node.children && node.children.length > 0 && renderTree(node.children)}
        </TreeItem>
      );
    });
  };



const [selectedFileDataRow,setSelectedFileDataRow] = useState({});

  // 处理点击事件
  const handleNodeClick = (node) => {
    if (node.ftype === 'folder') {
      console.log('Clicked on folder:', node.name);
      // 你可以在这里添加文件夹点击时的逻辑
    } else if (node.ftype === 'file') {
      setSelectedDocuemntID(node.id);
      setSelectedFileDataRow(node);
    }
  };

const [showMenuDoc,setShowMenuDoc] = useState(true);


const handleTabChange = (event, newValue) => {
  //setTabIndex(newValue);
  if (newValue === 1) {
    setShowMenuDoc(!showMenuDoc); // 隐藏菜单
  } 
  if (newValue === 2) {
    setShowAddDocment(true);
  } 
  
  
};


const [showAddDocment,setShowAddDocment] = useState(false);
const [createDocText,setCreateDocText] = useState("");
const [selectedCreateDocClassId, setSelectedCreateDocClassId] = useState(null);

const [anchorEl, setAnchorEl] = useState(null);
  const [selectedNode, setSelectedNode] = useState({ id: "", name: "" });
  const [expanded, setExpanded] = useState([]); // 控制展开的节点


  const [docType,setDocType] = useState("");
  
  const handleChangeDocType = (e) => {
    setDocType(e.target.value);

  }


const handleAddDoc = async () => {
  if(createDocText === ""){
    showSnackbar(t("请输入文档名称"),'warnning');
    return;
  }
  
  try {
    setIsLoading(true);
    const dataToSend = { 
      pid: selectedNode.id,
      dname:createDocText,
      ftype:docType,
    };
    console.log(JSON.stringify(dataToSend));
    const data = await requestUrl(dataToSend, "create_studydocument", showSnackbar);
    if (data.status === "success") {

      const tree = buildTree(data.data);
      setTreeData(tree);
      setFilteredTree(tree); // 初始值显示完整树
      
    }
} catch (error) {
    console.error("获取数据时出错:", error);
} finally {
    setIsLoading(false);
    setShowAddDocment(false);
}

}


const handleOnchangeCreateDocText = (e) => {
  setCreateDocText(e.target.value);
}

const handleChangePCCLassNameForCreatedoc = (e) => {
  setSelectedCreateDocClassId(e.target.value);
};

// 处理节点点击
const handleNodeClickAdd = (node) => {
  setSelectedNode({ id: node.id, name: node.name }); // 更新选中的值
    setAnchorEl(null); // 关闭弹出层
};
// 3. **递归渲染树**
const renderTree1 = (nodes) =>
  nodes.map((node) => (
    <TreeItem
      key={node.id}
      nodeId={String(node.id)}
      label={
        <div
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        >
          <div
            onClick={(event) => handleExpandClick(event, node.id)} // 仅箭头点击时展开
            style={{ marginRight: "5px" }}
          >
            {expanded.includes(node.id) ? <ExpandMoreIcon /> : <ChevronRightIcon />}
          </div>
          <div onClick={(event) => handleNodeClick1(event, node)}>{node.name}</div>
        </div>
      }
      sx={{
        "& .MuiTreeItem-label": { color: "white" },
      }}
    >
      {node.children.length > 0 && renderTree1(node.children)}
    </TreeItem>
  ));

  const handleCloseCreateDoc = () => {
    setShowAddDocment(false);
  }

  const inputStyles = {
    paddingRight: '40px', // 为发送按钮留出空间
    color:get_color_by_name('mui-textfield-text-color'),
    fontFamily: 'siyuan',
  };
  

  // 点击文本：选中节点并关闭菜单
  const handleNodeClick1 = (event, node) => {
    event.stopPropagation(); // 防止触发展开事件
    setSelectedNode({ id: node.id, name: node.name });
    setAnchorEl(null);
  };

  // 点击箭头：展开/折叠
  const handleExpandClick = (event, nodeId) => {
    event.stopPropagation(); // 防止触发选中事件
    setExpanded((prev) =>
      prev.includes(nodeId)
        ? prev.filter((id) => id !== nodeId) // 关闭
        : [...prev, nodeId] // 展开
    );
  };


  const [searchText, setSearchText] = useState("");
  const [filteredTree, setFilteredTree] = useState([]);

const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    if (!value) {
      setFilteredTree(treeData); // 为空时恢复完整树
      return;
    }

    const filterTree = (nodes) => {
      return nodes
        .map((node) => {
          if (node.name.toLowerCase().includes(value)) {
            return node; // 直接匹配返回节点
          }
          if (node.children) {
            const filteredChildren = filterTree(node.children);
            if (filteredChildren.length > 0) {
              return { ...node, children: filteredChildren }; // 仅保留匹配到的子节点
            }
          }
          return null;
        })
        .filter(Boolean);
    };

    setFilteredTree(filterTree(treeData));
  };

    return (
      <>
      <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", background: "#f5f5f5" }}>
        <Tabs value={tabIndex} onChange={handleTabChange}>
        <Tab label="主窗口" />
          <Tab label={showMenuDoc ? "隐藏菜单" : "显示菜单"} />
          <Tab label="添加文档" />
          
        </Tabs>
      </Box>

      {tabIndex === 0 && (
        <Box sx={{ display: "flex", backgroundColor:"#dfdfdf" }}>
          {showMenuDoc && (
           <ResizableBox
           width={300}
           height={800}
           axis="both"
           resizeHandles={["ne"]}
           handle={(h, ref) => (
             <span
               ref={ref}
               style={{
                 position: "absolute",
                 top: "100px",     // 从 bottom 改为 top
                 right: "5px",
                 fontSize: "20px",
                 color: "blue",
                 cursor: "ne-resize",  // 对应 north-east 拖动方向
                 userSelect: "none",
               }}
             >
               ↗
             </span>
           )}
         >
              


              <TextField
          value={searchText}
          onChange={handleSearch}
           placeholder={t("搜索")}
           InputProps={{ sx: inputStyles }}
           sx={{
             color: 'black',
             width: "90%",
             margin: "10px",
             "& .MuiInputBase-root": {
               backgroundColor: get_color_by_name("message-item-bg-all"),
             },
             "& .MuiOutlinedInput-root": {
               "&:hover fieldset": {
                 borderColor: get_color_by_name("mui-textfield-bg"),
               },
               "&.Mui-focused fieldset": {
                 borderColor: "primary.main",
               },
               "& fieldset": {
                 borderColor: get_color_by_name("mui-textfield-bg"),
               },
             },
             "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "black", // 默认边框颜色
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "white", // 悬停时边框颜色
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "white", // 聚焦时边框颜色
              },
           }}
         />

         
              <TreeView sx={{marginTop:"10px",height:"700px",overflowY: "auto"}} defaultCollapseIcon={<ExpandMoreIcon />} defaultExpandIcon={<ChevronRightIcon />}>
                {renderTree(filteredTree)}
              </TreeView>
            </ResizableBox>
          )}

          <Box sx={{ flex: 1, border: "1px solid black" }}>
            <WangEditorComponentCommon pcid={selectedDocuemntID} pid={selectedFileDataRow.pid} name={selectedFileDataRow.name} />
          </Box>
        </Box>
      )}
    </Box>


            {/* 如果窗口可见，则显示窗口 */}
            {isWindowVisible && (
        <div
          style={{
            position: "absolute", // 使用绝对定位
            top: "20px", // 距离顶部100px
            right: "40px", // 距离右侧40px
            zIndex: 1000, // 保证窗口在顶层
          }}
        >
          <Draggable handle=".draggable-header">
            <div>
              <ResizableBox
                width={windowSize.width}
                height={windowSize.height}
                minConstraints={[300, 300]}
                maxConstraints={[900, window.innerHeight * 1]}
                onResize={handleResize}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    height: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    overflow: "hidden",
                    backgroundColor: "white",
                  }}
                >
                  {/* 顶部区域，包含按钮和拖动 */}
                  <Box
                    className="draggable-header"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "40px",
                      backgroundColor: "#f5f5f5",
                      cursor: "move",
                      padding: "0 16px",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <Button variant="contained">顶部按钮</Button>
                  </Box>

                  {/* 中间区域，放置你的div */}
                  <Box
                    sx={{
                      flexGrow: 1,
                      padding: "16px",
                      overflowY: "auto",
                      backgroundColor: "#fafafa",
                    }}
                  >
                    {/* 这里放你的自定义内容 */}
                    <ChatWindow
                        width="100%"
                        height="50%"
                        messages={messages}
                        onSendMessage={handleSendMessage}
                        inputText={inputText}
                        setInputText={setInputText}
                        isLoading={isLoading}
                        subject='document'
                        fromModule='studydoc'
                      />
                  </Box>

                  {/* 底部区域，包含两个按钮 */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "8px 16px",
                      borderTop: "1px solid #ddd",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <Button variant="contained" onClick={handleCloseWindow}>
                      关闭窗口
                    </Button>
                    <Button variant="contained">底部按钮2</Button>
                  </Box>
                </Box>
              </ResizableBox>
            </div>
          </Draggable>
        </div>
            )}
  
            {showAddDocment && (
              <Box
              sx={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '40vw',
                height: '200px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                backgroundColor: get_color_by_name('pop-window-bg'),
                padding: 2,
                borderRadius: 2,
                boxShadow: 3,
                border: '1px solid white', // 添加黑色边框
              }}
            >
              <TextField
                value={ createDocText}
                onChange={handleOnchangeCreateDocText}
                placeholder={t("文档标题")}
                InputProps={{ sx: inputStyles }}
                sx={{
                  color: 'white',
                  width: "100%",
                  "& .MuiInputBase-root": {
                    backgroundColor: get_color_by_name("message-item-bg-all"),
                  },
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: "white", // 鼠标悬停时边框颜色
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "white", // 聚焦时边框颜色
                    },
                    "& fieldset": {
                      borderColor: "white", // 默认边框颜色
                    },
                  },
                }}
              />
    <FormControl sx={{ width: "95%", marginTop: "10px", height: "35px" }}>
                  <Select
                    sx={{
                      color: "white",
                      height: "35px",
                      fontSize: "14px", // 适当缩小字体
                      "& .MuiOutlinedInput-root": {
                        height: "35px",
                        padding: "0px", // 移除额外填充
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "white",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "white",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "white",
                      },
                    }}
                    labelId="platform-select-label"
                    value={docType}
                    onChange={handleChangeDocType}
                  >
                    <MenuItem value="file">file</MenuItem>
                    <MenuItem value="folder">folder</MenuItem>
                  </Select>
                </FormControl>
             <FormControl sx={{ width: "100%", marginTop: "10px", height: "35px" }}>
             <div>
      {/* 显示选中的值 */}
      <TextField
        value={selectedNode.name}
        placeholder="请选择"
        onClick={(e) => setAnchorEl(e.currentTarget)} // 点击时打开 TreeView
        fullWidth
        InputProps={{ readOnly: true }}
      />

      {/* 弹出 TreeView */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          "& .MuiPaper-root": {
            width: anchorEl?.offsetWidth || "auto", // 让 Popover 宽度等于 TextField
            backgroundColor: "black", // 设置背景色
            color: "white", // 设置文字颜色
            borderRadius: "8px", // 圆角
            padding: "8px",
          },
        }}
      >
        <TreeView
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          sx={{ maxHeight: 300, overflowY: "auto", minWidth: 200 }}
        >
          {renderTree1(treeDataFolder)}
        </TreeView>
      </Popover>
    </div>

            </FormControl>
    
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '0 10px' }}>
                  <CustomButton onClick={handleCloseCreateDoc} width="calc(50% - 5px)" sx={{ marginRight: '10px' }}>
                    {t("关闭")}
                  </CustomButton>
                  <CustomButton onClick={handleAddDoc} width="calc(50% - 5px)">
                    {t("添加")}
                  </CustomButton>
              </Box>
    
            </Box>

            )}

      {isLoading && (
        <LoadingData text={t(loadingText)}/>
      )}
        </>
    );
};

export default StudyDocumentComponent;
